import React from 'react';
import { Heading } from 'elements';
import {
  StyledList,
  StyledNavLink,
  StyledListDiv,
  StyledListWraper,
  StyledNr
   } from './styled';
import {
  Flex,
  FlexItem
} from 'core/layout';


class Apaksraksti extends React.PureComponent {
    render () {
        const { currentPath, subpages } = this.props;
        if (subpages && Array.isArray(subpages) && subpages.length > 0) {

          return (
            <StyledListWraper>
            <Flex wrap='true' length={2}>
                <FlexItem basis={4 / 8} >
                    {subpages.slice(0, Math.ceil(subpages.length/2)).map((page, i) => page && (
                      <StyledListDiv key={i}>
                        <StyledNr>{i+1}.</StyledNr>
                        <StyledNavLink
                          key={i}
                          rel='help'
                          to={page.path}
                          isActive={() => page.path === currentPath}
                        >
                          {page.title}
                        </StyledNavLink>
                      </StyledListDiv>
                    ))}
                </FlexItem>

                <FlexItem basis={4 / 8} >
                    {subpages.slice(Math.ceil(subpages.length/2), subpages.length).map((page, i) => page && (
                      <StyledListDiv key={i}>
                        <StyledNr>{i+1+Math.ceil(subpages.length/2)}.</StyledNr>
                        <StyledNavLink
                          key={i}
                          rel='help'
                          to={page.path}
                          isActive={() => page.path === currentPath}
                        >
                          {page.title}
                        </StyledNavLink>
                      </StyledListDiv>
                    ))}
                </FlexItem>
            </Flex>
            </StyledListWraper>
          );
        }

        return null;
    }
}

export default Apaksraksti;



// WEBPACK FOOTER //
// ./src/pages/Raksts/components/Apaksraksti/Apaksraksti.jsx